import router from '../router/index'
import store from '../store/index'

router.beforeEach((to, from, next) => {
//   // 从首页进去——LookPublishing商品列表【精品大码洋/畅销书/医学/抗疫图书/出版社推荐/地方出版社】
//   if (from.path === '/') {
//     // goodsType:1 纸质书  2：电子书
//     // Cookies.set('goodsType', 1)
//     // 控制试读按钮
//     store.state.DataStorage.TryBookShow = false
//     // 有关联的电子书/纸质书 文字的问题
//     store.state.DataStorage.TryBookFont = '有电子书'
//   }
//   // 从BookElectron纸电同步——LookPublishing商品列表
//   if (from.path === '/BookElectron') {
//     // Cookies.set('goodsType', 2)
//     store.state.DataStorage.TryBookShow = true
//     store.state.DataStorage.TryBookFont = '有纸质书'
//   }

  // 从商品列表页-详情页的时候，保存状态
//   console.log(from)
  if(from.name === 'HomePage' || from.name === 'commonLibrary' || from.name === 'SchoolLibrary' ||　from.name === 'PublisherBook'　||　from.name === 'BookElectron'　||　from.name === 'PublisherChildsCoalition'||　from.name === 'PublisherChildsPlaces'){
    store.state.DataStorage.CookiePages = true
  }else{
    store.state.DataStorage.CookiePages = false
  }

  next()
})

router.afterEach((to, from) => { })



// WEBPACK FOOTER //
// ./src/sealFilter/permission.js